module.exports = __webpack_public_path__ + "img/img_sasclinic.9493a8bd.jpg";